import { LampDesk, LayoutGrid, ListChecks, Lock, ShieldCheck, SquareLibrary } from 'lucide-react';

export const informationLinksItems = [
  {
    title: 'What do we do?',
    description:
      "Your operations depend on software you don't always control. We protect that with escrow solutions that guarantee your software resilience.",
    icon: LampDesk,
    href: 'https://codekeeper.co/how-it-works',
    linkText: 'Learn how it works',
  },
  {
    title: 'Information Security',
    description:
      'Codekeeper specializes in software resilience. Visit our Security Portal to learn more about how we protect your information.',
    icon: Lock,
    href: 'https://codekeeper.co/security-portal',
    linkText: 'Go to Security Portal',
  },
  {
    title: 'Integration support',
    description:
      'Codekeeper integrates with the tools you already use. You can easily deposit your assets and keep them in sync.',
    icon: LayoutGrid,
    href: 'https://codekeeper.co/integrations',
    linkText: 'Explore our integrations',
  },
  {
    title: 'Verify your escrow',
    description:
      "We run verifications to check your software's reliability and provide certificates that meet every regulatory and client requirement.",
    icon: ShieldCheck,
    href: 'https://codekeeper.co/verification',
    linkText: 'Learn about verifications',
  },
  {
    title: 'What verification to get?',
    description: 'Determine which verification level best suits your business needs. ',
    icon: ListChecks,
    href: 'https://codekeeper.co/verification-questionnaire',
    linkText: 'Complete questionnaire',
  },
  {
    title: 'Want to learn more?',
    description: 'Discover more about escrow and software resilience with our downloadable resources.',
    icon: SquareLibrary,
    href: 'https://codekeeper.co/resources',
    linkText: 'Browse guides',
  },
];
